import React from 'react';
import { Link } from 'react-router-dom';
import { LuCircleCheck, LuArrowRight } from 'react-icons/lu';
import XiLogo from '../components/ui/XiLogo';

/**
 * Payment success result screen.
 * Presentation only — the checkout flow itself is unchanged.
 */
const PaymentSuccess = () => {
  return (
    <div className="xi-public xi-result">
      <div className="xi-public__veil" aria-hidden="true" />
      <div className="xi-public__body xi-result__body">
        <div className="xi-enroll__brand">
          <XiLogo size="sm" tagline />
        </div>

        <div className="xi-auth-card xi-result__card" role="status">
          <span className="xi-result__icon is-ok" aria-hidden="true">
            <LuCircleCheck />
          </span>
          <span className="xi-eyebrow">Payment complete</span>
          <h1>Payment successful</h1>
          <p className="xi-muted">
            Thank you! Your payment has been processed successfully.
          </p>

          <div className="xi-result__actions">
            <Link to="/dashboard" className="xi-btn xi-btn--primary xi-btn--lg">
              Go to Dashboard
              <LuArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
